import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Demo2Nav from '../layout/Demo2Nav';
import Demo2PhotoLightbox from '../Demo2PhotoLightbox';
import { useDemo2Ctx } from '../Demo2Context';
import { findZone, STATUS_LABEL, STATUS_COLOR, TYPE_ICON_RI, WORK_PHOTOS, type SitePhoto } from '../demo2Data';

const STEP_LABELS = ['확인', '시작', '입력', '완료'];

export default function Demo2MWorkProcess() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { workOrders, startWorkOrder, completeWorkOrder, toast } = useDemo2Ctx();

    const wo = workOrders.find(w => w.id === id) ?? workOrders.find(w => w.status !== 'done') ?? workOrders[0];
    const [step, setStep] = useState(wo.status === 'progress' ? 1 : 0);
    const [amt, setAmt] = useState('1200');
    const [mins, setMins] = useState('55');
    const [note, setNote] = useState('');
    const [photos, setPhotos] = useState<SitePhoto[]>(WORK_PHOTOS.slice(0, 3));
    const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);
    const photoCount = photos.length;

    const z = findZone(wo.zone);

    const start = () => {
        startWorkOrder(wo.id);
        toast('작업이 시작되었습니다 · GPS 위치가 기록되었습니다', 'success');
        setStep(1);
    };
    const addPhoto = () => {
        const next = WORK_PHOTOS[photos.length % WORK_PHOTOS.length];
        setPhotos(p => [...p, next]);
        toast(`사진이 첨부되었습니다 (${photos.length + 1}장)`, 'success');
    };
    const complete = () => {
        completeWorkOrder(wo.id, `관개량 ${amt}L, 소요 ${mins}분. ${note}`, `${amt}L`, `${mins}분`);
        setStep(3);
    };

    return (
        <>
            <Demo2Nav />
            <div className="sian sian-mobile-stage">
                <div className="phone-frame">
                    <div className="phone-notch" />
                    <div className="phone-screen">
                        <div className="m-statusbar">
                            <span>9:41</span>
                            <span className="m-statusbar-icons"><i className="ri-signal-wifi-line" /><i className="ri-battery-2-line" /></span>
                        </div>
                        <div className="m-header">
                            <div className="m-header-back" onClick={() => navigate('/demo2/mobile/worklist')}><i className="ri-arrow-left-line" /></div>
                            <div className="m-header-ttl">작업 처리</div>
                        </div>
                        <div className="stepper">
                            {STEP_LABELS.map((l, i) => (
                                <div key={l} className={`step ${i < step ? 'done' : i === step ? 'active' : ''}`}>
                                    <div className="step-dot">{i < step ? <i className="ri-check-line" /> : i + 1}</div>
                                    <div className="step-lbl">{l}</div>
                                </div>
                            ))}
                        </div>

                        <div className="m-body">
                            <div className="m-body-p">
                                {step === 0 && z && (
                                    <>
                                        <div className="m-card">
                                            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <span className="d2-ico d2-ico-sm d2-ico-green"><i className={TYPE_ICON_RI[wo.type]} /></span>{wo.title}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 9, fontSize: 12.5, color: 'var(--text2)', fontWeight: 600 }}>
                                                <div><i className="ri-map-pin-line" /> 위치 : {wo.zoneName} ({z.district})</div>
                                                <div><i className="ri-plant-line" /> 대상 : {z.treeName} 외 {z.treeCount}주</div>
                                                <div><i className="ri-calendar-line" /> 예정일 : {wo.due}</div>
                                                <div><i className="ri-user-3-line" /> 담당 : {wo.assignee}</div>
                                            </div>
                                        </div>
                                        <div className="m-card">
                                            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text2)', marginBottom: 9 }}>현재 수분 상태</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                <span style={{ fontSize: 26, fontWeight: 900, color: STATUS_COLOR[z.status] }}>{z.moist}%</span>
                                                <span className={`badge badge-${z.status}`}>{STATUS_LABEL[z.status]}</span>
                                            </div>
                                        </div>
                                        <div className="m-gps-badge"><i className="ri-navigation-line" /> GPS 확인됨 · 대상 구역 반경 120m 이내</div>
                                    </>
                                )}
                                {step === 1 && (
                                    <>
                                        <div className="m-card" style={{ textAlign: 'center', padding: '30px 16px' }}>
                                            <div className="d2-ico d2-ico-xl d2-ico-blue" style={{ margin: '0 auto 14px' }}><i className="ri-time-line" /></div>
                                            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>작업 진행 중</div>
                                            <div className="text-xs text-muted">시작 시각 09:12 · {wo.zoneName}</div>
                                        </div>
                                        <div className="m-gps-badge"><i className="ri-navigation-line" /> 현장 위치 확인됨</div>
                                    </>
                                )}
                                {step === 2 && (
                                    <>
                                        <div className="form-group" style={{ marginBottom: 12 }}><label className="form-label">관개량 (Liter)</label><input type="number" className="form-input" value={amt} onChange={e => setAmt(e.target.value)} /></div>
                                        <div className="form-group" style={{ marginBottom: 12 }}><label className="form-label">소요 시간 (분)</label><input type="number" className="form-input" value={mins} onChange={e => setMins(e.target.value)} /></div>
                                        <div className="form-group" style={{ marginBottom: 12 }}><label className="form-label">특이사항</label><textarea className="form-textarea" placeholder="작업 중 관찰된 특이사항을 입력하세요" value={note} onChange={e => setNote(e.target.value)} /></div>
                                        <div className="form-group" style={{ marginBottom: 6 }}>
                                            <label className="form-label">현장 사진 (필수) · {photoCount}장 등록됨</label>
                                            <div className="photo-drop" onClick={addPhoto}><div className="photo-drop-ico"><i className="ri-camera-line" /></div><div className="photo-drop-txt">탭하여 사진 촬영 / 첨부</div></div>
                                            <div className="photo-thumbs">
                                                {photos.map((p, i) => (
                                                    <div key={i} className="photo-thumb photo-thumb-img" onClick={() => setLightboxIdx(i)}>
                                                        <img src={p.src} alt={p.caption} loading="lazy" />
                                                        <button className="photo-thumb-remove" onClick={e => { e.stopPropagation(); setPhotos(ph => ph.filter((_, idx) => idx !== i)); }} aria-label="사진 삭제">
                                                            <i className="ri-close-line" />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="m-gps-badge" style={{ marginTop: 8 }}><i className="ri-navigation-line" /> GPS 위치 재확인 완료</div>
                                    </>
                                )}
                                {step === 3 && (
                                    <>
                                        <div className="m-card" style={{ textAlign: 'center', padding: '34px 16px' }}>
                                            <div className="d2-ico d2-ico-xl d2-ico-green" style={{ margin: '0 auto 16px' }}><i className="ri-checkbox-circle-line" /></div>
                                            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 6 }}>작업이 완료되었습니다</div>
                                            <div className="text-xs text-muted" style={{ lineHeight: 1.7 }}>이력이 자동 등록되었으며<br />Web 대시보드에 실시간 동기화되었습니다</div>
                                        </div>
                                        <div className="m-card">
                                            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text2)', marginBottom: 8 }}>작업 요약</div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, color: 'var(--text2)', fontWeight: 600 }}>
                                                <div>{wo.zoneName} · {wo.type}</div><div>완료 시각 {wo.completedAt}</div><div>{wo.result}</div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="m-btn-bar">
                            {step === 0 && <button className="btn btn-primary w-full btn-lg" onClick={start}><i className="ri-play-line" /> 작업 시작</button>}
                            {step === 1 && <button className="btn btn-primary w-full btn-lg" onClick={() => setStep(2)}><i className="ri-edit-line" /> 작업 내용 입력하기</button>}
                            {step === 2 && <button className="btn btn-primary w-full btn-lg" disabled={photoCount === 0} onClick={complete}><i className="ri-check-line" /> {photoCount === 0 ? '작업 완료 (사진 첨부 필요)' : '작업 완료'}</button>}
                            {step === 3 && <button className="btn btn-secondary w-full" onClick={() => navigate('/demo2/mobile/worklist')}>목록으로 돌아가기</button>}
                        </div>
                    </div>
                </div>
            </div>
            {lightboxIdx !== null && (
                <Demo2PhotoLightbox photos={photos} index={lightboxIdx} onClose={() => setLightboxIdx(null)} onIndexChange={setLightboxIdx} />
            )}
        </>
    );
}
